<template>
  <main>
    <div class="container">
      <!-- Кнопка для меня(очищает корзину в localStorage) -->
      <!-- <p @click="clear">clear</p> -->
      <div class="main-wrapper product-card" ref="wrapper">
        <!-- Content header start -->
        <div class="product-info" v-if="dataLoaded">
          <div
            class="product-info__img"
            v-bind:style="{backgroundImage: 'url(' + productInfo.previewPicture + ')'}"
          ></div>

          <!-- Информация о товаре в хэдэре start -->
          <div class="product-info__list">
            <h1 class="product-info__title">{{productInfo.name}}</h1>
            <b-link v-b-modal.modalPassport class="product-info__link"
              >паспорт модели</b-link
            >
            <div class="product-info__price" >
              <span>от </span>
              <span class="num">{{productInfo.price.value}}</span>
              <span> {{productInfo.price.valuta}} / {{productInfo.price.measure}}</span>
            </div>
          </div>
          <!-- Информация о товаре в хэдэре end -->
        </div>
        <!-- Content header end -->

        <!-- Content main start -->
        <div class="order-block">
          <h2 class="grey-title">Отстройка</h2>
          <div class="order-form">
            <div class="order-for__heading">
              <p class="left-col">Сезон</p>
              <p class="center-col">Продажи</p>
              <p class="right-col">Отстроено</p>
            </div>
            <VariationItem
              v-for="(item, index) in productInfo.offers"
              :key="index"
              :info="item"
              :collectionID="collection"
              :name="productInfo.name"
            ></VariationItem>
          </div>
        </div>
        <!-- Content main end -->
      </div>
    
      <ControlFeedback
        :collection="collection"
        :element="element"
        :productInfo="productInfo"
      ></ControlFeedback>
      <!-- nav start -->
      <Navigation
        :collection="collection"
        :element="element"
        :productInfo="productInfo"
      ></Navigation>
      <!-- nav end -->
    </div>
  </main>
</template>
<script>
import ModalSlider from "@/components/modal/modalSlider";
import ModalPassport from "@/components/modal/ModalPassport";
import Navigation from "@/components/navigation/controlPagination";
import VariationItem from "@/components/productCard/controlVariationItem";
import ControlFeedback from "@/components/productCard/controlFeedback";

export default {
  props: ["collection", "element"],
  components: { ModalSlider, ModalPassport, Navigation, VariationItem, ControlFeedback },
  data: () => ({
    productInfo: {}, //Полнаяя информация о текущем товаре
    dataLoaded: false
  }),
  methods: {
    startComponent(){
      return this.$store
        .dispatch("CONTROL_GET_CURRENT_PRODUCT", {
          collectionID: this.collection,
          productID: this.element,
        })
        .then((r) => {
          this.productInfo = r;
        })
        .then((r) => (this.dataLoaded = true)); //Данные полностью загружены
    }
  },
  created(){
    this.startComponent();
  },
  watch: {
    '$route'(){
      this.startComponent()
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  overflow: hidden;
}
h2 {
  padding: 0;
}
.order-for__heading {
  width: 100%;
  display: flex;
}
.order-for__heading {
  height: 20px;
  margin: 10px 0 20px 0;
  .left-col,
  .center-col {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: bold;
    width: 35%;
  }
  .right-col{
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: bold;
    width: 30%;
    justify-content: center;
  }
}
.order-form {
  display: flex;
  flex-direction: column;
}

.product-card {
  height: calc(100vh - 220px);
  position: relative;
}
.product-info {
  padding-bottom: 10px;
}

</style>

